( function ($){

    $ (document).ready (function ($){

        var hexagonBtn = $ ('.find-distributor-widget .hexagons-wrapper .country');

        hexagonBtn.on ('click', function (){

            var contact = $ ('.find-distributor-widget .contacts-wrapper .contact-wrapper')
            hexagonBtn.removeClass ('active');
            contact.removeClass ('active');
            $ (this).addClass ('active');

            var indexBtn = $ (this).data ('index');
            $ ('.find-distributor-widget .contacts-wrapper').find (".contact-wrapper[data-index='" + indexBtn + "']").addClass ('active');

            if ($(window).width () < 768) {
                $ ([document.documentElement, document.body]).animate ({
                    scrollTop: $ ('.find-distributor-widget .clone-contacts-wrapper').offset ().top - 85
                }, 1000);
            }
        });

        var cloneContactsWrapper = $ ('.find-distributor-widget .contacts-wrapper').clone ();
        $ ('.clone-contacts-wrapper').html (cloneContactsWrapper);


    });

} ) (jQuery);
